module.exports = __webpack_public_path__ + "img/1f924.5514daf.svg";